import React from 'react';

interface SLAGaugeProps {
  value: number;
  darkMode?: boolean;
  onTime?: number;
  late?: number;
  title?: string;
  icon?: React.ReactNode;
  className?: string;
}

const SLAGauge: React.FC<SLAGaugeProps> = ({
  value,
  onTime = 0,
  late = 0,
  title = 'SLA Cumplido',
  icon,
  className = '',
}) => {
  const clamped = Math.min(100, Math.max(0, value));
  const barColor = clamped >= 90 ? 'bg-emerald-500' : clamped >= 70 ? 'bg-amber-500' : 'bg-red-500';
  const textColor = clamped >= 90 ? 'text-emerald-600 dark:text-emerald-400' : clamped >= 70 ? 'text-amber-600 dark:text-amber-400' : 'text-red-600 dark:text-red-400';

  return (
    <div className={`flex flex-col ${className}`}>
      {(icon || title) && (
        <div className="flex items-center gap-2 mb-0.5">
          {icon && <span className="flex-shrink-0">{icon}</span>}
          <h3 className="text-xs font-medium text-gray-600 dark:text-gray-400 truncate">{title}</h3>
        </div>
      )}
      <p className={`text-xl font-bold ${textColor}`}>{clamped}%</p>
      <div className="h-2 bg-gray-200/80 dark:bg-gray-700 rounded-full overflow-hidden mt-2">
        <div className={`h-full ${barColor} rounded-full transition-all duration-500 ease-out`} style={{ width: `${clamped}%` }} />
      </div>
      {onTime > 0 || late > 0 ? (
        <div className="mt-1 flex gap-3 text-[10px] text-gray-500 dark:text-gray-400">
          <span><strong className="text-emerald-600 dark:text-emerald-400">{onTime}</strong> a tiempo</span>
          <span><strong className="text-red-600 dark:text-red-400">{late}</strong> atrasadas</span>
        </div>
      ) : null}
    </div>
  );
};

export default SLAGauge;
